import InputText from './InputText';

export default InputText;
